import { defineMessages, enPlural, ruPlural } from '@/i18n'

export const messages = defineMessages({
  ru: {
    exploreToggle: 'Показывать в Explore',
    exploreHint:
      'Курсы из каталога видны в Explore всегда. Галочка нужна курсу «по ссылке»: с ней он тоже появится в Explore.',
    videoCheckFailed: 'Не удалось проверить видео-блоки урока.',
    retry: 'Повторить',
    screen: (lessonNo: string) => `${lessonNo} → Блок`,
    screenDeleted: (lessonNo: string) => `${lessonNo} → Блок (удалён)`,
    screenN: (lessonNo: string, n: number) => `${lessonNo} → Блок ${n}`,
    image: 'Картинка',
    article: 'Статья',
    course: 'Курс',
    mascot: 'Маскот',
    lessonDeleted: 'Урок (удалён)',
    lessonN: (n: number) => `Урок ${n}`,
    inTelegram: 'В Telegram',
    inWeb: 'В веб-версии',
    linkCopied: 'Ссылка скопирована',
    linkCopyFailed: 'Не удалось скопировать ссылку',
    copyLink: (label: string) => `Скопировать ссылку ${label}`,
    courseLink: 'Ссылка на курс',
    updateSection: 'Обновление',
    // Родительный падеж: «прогресс 1 ученика», «прогресс 3 учеников».
    impactTitle: (n: number) =>
      `Прогресс ${n} ${ruPlural(n, 'ученика', 'учеников', 'учеников')} пропадёт`,
    impactBody: 'После одобрения обновления прогресс по этим блокам не вернуть.',
    removedBlocks: (n: number) => `Удаляемых блоков: ${n}`,
    retypedBlocks: (n: number) => `Блоков со сменой типа: ${n}`,
    cancel: 'Отмена',
    send: 'Отправить',
    updateSent: 'Изменения отправлены на проверку',
    statusLoadFailed: 'Не удалось загрузить статус публикации',
    statusLoading: 'Загружаю статус публикации…',
    closeAccess: 'Закрыть доступ',
    changes: 'Есть неопубликованные изменения',
    liveChanges:
      'Вы изменили опубликованный курс. Чтобы изменения увидели ученики, нажмите «Обновить».',
    draftChanges:
      'Курс закрыт. Отправьте правки на проверку — после одобрения они станут основной версией.',
    sendUpdate: 'Обновить',
    sendUpdateFixed: 'Исправлено, обновить',
    updateApprovedTitle: 'Опубликована актуальная версия',
    updateApprovedBody: 'Неопубликованных изменений нет.',
    updating: 'Обновляю…',
    discarding: 'Возвращаю…',
    discardChanges: 'Вернуть опубликованную версию',
    saveScreenFirst: 'Сначала сохраните блок',
    retryIn: (label: string) => `Повторить можно через ${label}`,
    platformWeb: 'Веб-версия',
    showOnPlatforms: 'Показывать на платформах',
    experimentalTitle: 'Экспериментальный доступ',
    experimentalBody:
      'Сейчас вам доступна публикация только по ссылке. Дождитесь полного доступа, и курсы можно будет публиковать в каталог.',
    ownTma: 'Свой TMA',
    soon: 'скоро',
    courseAccess: 'Доступ к курсу',
    catalogSection: 'Раздел каталога',
    discardSubject: 'курса',
    discardNote:
      'Несохранённая правка блока останется в форме — её сохранение заведёт новый черновик. Блок, которого нет в живой версии курса, пропадёт вместе с правкой',
    inReview: 'Курс на проверке. Редактирование недоступно до решения.',
    reviewingUpdateTitle: 'Проверяем обновление',
    reviewingCourseTitle: 'Проверяем ваш курс',
    reviewingCourseBody:
      'Обычно это занимает меньше минуты. Пока идёт проверка, курс нельзя править.',
    reviewingUpdateBody:
      'Обычно это занимает меньше минуты. Пока идёт проверка, ученики видят прежнюю версию, а курс нельзя править.',
    withdraw: 'Отозвать заявку',
    sentToReview: 'Курс отправлен на проверку',
    closed: 'Курс закрыт',
    byLink: 'Доступ по ссылке',
    inCatalog: 'Курс в каталоге',
    publishCourse: 'Публикация курса',
    close: 'Закрыть',
  },
  en: {
    exploreToggle: 'Show in Explore',
    exploreHint:
      'Catalog courses are always visible in Explore. The checkbox is for a course shared by link: with it, the course shows up there too.',
    videoCheckFailed: 'Couldn’t check the lesson’s video blocks.',
    retry: 'Retry',
    screen: (lessonNo: string) => `${lessonNo} → Block`,
    screenDeleted: (lessonNo: string) => `${lessonNo} → Block (deleted)`,
    screenN: (lessonNo: string, n: number) => `${lessonNo} → Block ${n}`,
    image: 'Image',
    article: 'Article',
    course: 'Course',
    mascot: 'Mascot',
    lessonDeleted: 'Lesson (deleted)',
    lessonN: (n: number) => `Lesson ${n}`,
    inTelegram: 'In Telegram',
    inWeb: 'On the web',
    linkCopied: 'Link copied',
    linkCopyFailed: 'Couldn’t copy the link',
    copyLink: (label: string) => `Copy link (${label})`,
    courseLink: 'Course link',
    updateSection: 'Update',
    impactTitle: (n: number) =>
      `${n} ${enPlural(n, 'learner', 'learners')} will lose their progress`,
    impactBody: 'Once the update is approved, progress on these blocks can’t be restored.',
    removedBlocks: (n: number) => `Blocks to be removed: ${n}`,
    retypedBlocks: (n: number) => `Blocks changing type: ${n}`,
    cancel: 'Cancel',
    send: 'Send',
    updateSent: 'Changes sent for review',
    statusLoadFailed: 'Couldn’t load publication status',
    statusLoading: 'Loading publication status…',
    closeAccess: 'Make private',
    changes: 'There are unpublished changes',
    liveChanges: 'You changed the published course. To show the changes to learners, click Update.',
    draftChanges:
      'The course is private. Send your edits for review — once approved, they become the main version.',
    sendUpdate: 'Update',
    sendUpdateFixed: 'Send fixed update',
    updateApprovedTitle: 'The current version is published',
    updateApprovedBody: 'There are no unpublished changes.',
    updating: 'Updating…',
    discarding: 'Reverting…',
    discardChanges: 'Revert to published version',
    saveScreenFirst: 'Save the block first',
    retryIn: (label: string) => `You can retry in ${label}`,
    platformWeb: 'Web app',
    showOnPlatforms: 'Show on platforms',
    experimentalTitle: 'Experimental access',
    experimentalBody:
      'For now you can only publish by link. Once you get full access, you’ll be able to publish courses to the catalog.',
    ownTma: 'Your own TMA',
    soon: 'Soon',
    courseAccess: 'Course access',
    catalogSection: 'Catalog section',
    discardSubject: 'the course',
    discardNote:
      'Your unsaved block edit will stay in the form — saving it will create a new draft. A block that isn’t in the published version of the course will disappear along with the edit',
    inReview: 'The course is under review. You can’t edit it until the review is done.',
    reviewingUpdateTitle: 'Reviewing your update',
    reviewingCourseTitle: 'Reviewing your course',
    reviewingCourseBody:
      'This usually takes less than a minute. Until it finishes, the course can’t be edited.',
    reviewingUpdateBody:
      'This usually takes less than a minute. Until it finishes, learners see the previous version and the course can’t be edited.',
    withdraw: 'Withdraw request',
    sentToReview: 'Course sent for review',
    closed: 'Course is private',
    byLink: 'Access by link',
    inCatalog: 'Course is in the catalog',
    publishCourse: 'Publish course',
    close: 'Close',
  },
})
